// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"0b5de098","325":"0b5de098","412":"768b25a3","431":"aa5dd306","607":"aa5dd306","631":"0b5de098","653":"aa5dd306","936":"0b5de098"}[chunkId] + ".chunk.css";
};